import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Image = styled.img`
  width: 100px;
  height: auto;
  margin: 15px 15px 15px -60px;
  position: absolute;
  left: 50%;
`;

const GetImage = (companyName) => {
  switch (companyName) {
    case 'AML':
      return '/assets/images/aml-logo.png';
    case 'STENALINE':
      return '/assets/images/stenaline-logo.png';
    default:
      return '/assets/images/glow-logo.png';
  }
};

const DynamicLogo = props => <Image src={GetImage(props.companyName)} alt="logo" />;

DynamicLogo.propTypes = {
  companyName: PropTypes.string.isRequired,
};

export default DynamicLogo;



// WEBPACK FOOTER //
// ./src/components/organisms/DynamicLogo/index.js